module.exports = {
          srcSet: __webpack_public_path__ + "public/a99153c6584735855f0fc1ea1b8fc137-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/a99153c6584735855f0fc1ea1b8fc137-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/a99153c6584735855f0fc1ea1b8fc137-80.png",
          toString:function(){return __webpack_public_path__ + "public/a99153c6584735855f0fc1ea1b8fc137-80.png"},
          
          width: 80,
          height: 80
        }